import styled, { css } from 'styled-components';

export const IconWrapper = styled.span`
  display: block;

  ${({ inline, scaled, size }) => css`
    ${inline &&
    css`
      display: inline-block;
      vertical-align: middle;
      margin-top: -0.1875em;
    `};

    ${scaled &&
    css`
      width: 100%;
      height: 100%;
    `};

    & svg {
      display: block;
      fill: currentColor;
      width: 18px;
      height: 18px;

      ${scaled &&
      css`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      `};
      ${size &&
      css`
        ${size === 'regular' &&
        css`
          width: 24px;
          height: 24px;
        `}
        ${size === 'medium' &&
        css`
          width: 36px;
          height: 36px;
        `}
        ${size === 'large' &&
        css`
          width: 48px;
          height: 48px;
        `}
      `}
    }
  `};
`;
